var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2205 0.167954C14.767 -0.0559845 14.233 -0.0559845 13.7795 0.167954L0.890606 6.5316C0.344778 6.80108 0 7.35197 0 7.95456V17.5C0 21.7353 1.38643 25.2816 3.8714 28.1847C6.33047 31.0574 9.80314 33.2306 13.89 34.8815C14.2809 35.0395 14.7191 35.0395 15.11 34.8815C19.1969 33.2306 22.6695 31.0574 25.1287 28.1847C27.6136 25.2816 29 21.7353 29 17.5V7.95456C29 7.35197 28.6552 6.80108 28.1094 6.5316L15.2205 0.167954ZM3.22222 8.93779V17.5C3.22222 20.9881 4.34198 23.8056 6.33229 26.1307C8.23908 28.3583 11.0004 30.196 14.5 31.6839C17.9995 30.196 20.7609 28.3583 22.6677 26.1307C24.6581 23.8056 25.7778 20.9881 25.7778 17.5V8.93779L14.5 3.3696L3.22222 8.93779Z",
    fill: "url(#paint0_linear_441_3)",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1644 13.7665C22.7455 13.1013 22.6706 12.0967 21.9968 11.5227C21.3232 10.9488 20.3058 11.0228 19.7245 11.6881L12.5066 19.9494L9.18369 16.7313C8.54843 16.1161 7.52838 16.1258 6.90533 16.7531C6.28229 17.3804 6.29218 18.3876 6.92742 19.0028L11.4764 23.4085C11.7943 23.7163 12.2269 23.8805 12.6715 23.8622C13.1164 23.8439 13.5337 23.6448 13.8245 23.3119L22.1644 13.7665Z",
    fill: "#4860AC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_3",
    x1: 0,
    y1: 0,
    x2: 37.1106,
    y2: 15.2061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#943939",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4860AC",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.211d9b84a79164b21ece73dbbc4991f0.svg";
export { ForwardRef as ReactComponent };